import React, { useState } from 'react'
import { getAuthHeader, validateFunctionalForm } from '../../../utils';
import { v3_add_document_comment } from '../../../actions/v3/document';
import { toast } from 'react-toastify';
import moment from 'moment';
import axios from 'axios';
import fileDownload from 'js-file-download';
import FileDropdownPreviewMenu from '../../common/FileDropdownPreviewMenu';


const DocumentDetail = ({ data, refresh, setRefresh }) => {
    const [state, setState] = useState({
        comment: { name: 'comment', value: '', isRequired: true, error: '' },
    });
    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({
            ...prev,
            [name]: { ...prev[name], value },
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {
                comment: state.comment.value,
                documentId: data.DOCUMENT_ID
            }
            v3_add_document_comment(model).then((res) => {
                if (res.status) {
                    toast.success(res.result.message)
                    setRefresh(!refresh)
                    setState((prev) => ({
                        ...prev,
                        ['comment']: { ...prev['comment'], value: '' },
                    }));
                }
            })
        }
    }


    const handleDownload = async (documentId) => {
        try {
            const downloadUrl = `${process.env.REACT_APP_BASE_URL}/v3/document/download/files/${documentId}`;
            let config = { responseType: 'blob' };
            const authHeader = getAuthHeader();
            if (authHeader?.headers) {
                config.headers = {
                    ...config.headers,
                    ...authHeader.headers,
                };
            }
            const response = await axios.get(downloadUrl, config);
            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `document_${documentId}_files.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error?.response?.data || error.message);
            toast.error("Download failed. Please check if the document has valid files or contact support.");
        }
    };

    const handleDownloadFile = async (documentId, fileName, downloadName = fileName) => {
        try {
            let config = { responseType: 'blob' }
            const authHeader = getAuthHeader();
            if (authHeader?.headers) {
                config.headers = {
                    ...config.headers,
                    ...authHeader.headers,
                };
            }
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/v3/document/download/file/${documentId}/${encodeURIComponent(fileName)}`,
                config
            );

            fileDownload(response.data, downloadName);
        } catch (error) {
            console.error("Download failed:", error);
            toast.error("Failed to download file.");
        }
    };

    return (
        <div className="card card-right-doc-aside bsn">
            <div className="card-body pdl0 pdr0">
                <div className='right-taitlebox'>
                    <h4>{data.DOCUMENT_NAME}</h4>
                    <h6>{data.HULL_NUMBER} - {data.SHIP_NAME}</h6>
                    <span className="badge rounded-pill bg-info"
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, #0ddcef, #319bfc)",
                            fontSize: 11
                        }}
                    >{data.DOCUMENT_TYPE}
                    </span>
                </div>
                <div className="table-responsive tableexInfo">
                    <table className="table-rev-doc table align-middle table-nowrap table-hover">
                        <thead className="table-light">
                            <tr>

                                <th scope="col">REV</th>
                                <th scope="col">FILES</th>

                                <th scope="col">UPLOADED</th>
                                <th scope="col">REMARK</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>

                                <td>
                                    {/* <p className="text-muted mb-0">{data.FILE_COUNT} Files <span><a href="javascript:void(0)"><i className="fa fa-download" aria-hidden="true" style={{ color: "#f46a6a" }} ></i></a></span></p> */}
                                    <div className="dropdown hover-dropdown">
                                        <span
                                            className="text-muted mb-0 dropdown-toggle"
                                            role="button"
                                        >
                                            {data.FILE_COUNT} Files{" "}
                                            <span style={{ color: "#08c" }}>
                                                <i
                                                    className="fa fa-download"
                                                    style={{ color: "#f46a6a" }}
                                                    aria-hidden="true"
                                                />
                                            </span>
                                        </span>
                                        <FileDropdownPreviewMenu
                                            files={(data.files || []).map((file, index) => {
                                                const rawFileName = file.FILE_NAME || file.fileName || '';
                                                const encodedFileName = encodeURIComponent(rawFileName);
                                                const displayName = file.ORIGINAL_FILE_NAME || file.originalFileName || rawFileName || `File ${index + 1}`;
                                                return {
                                                    id: `${data.DOCUMENT_ID}-${rawFileName || 'file'}-${index}`,
                                                    name: displayName,
                                                    previewUrl: rawFileName
                                                        ? `${process.env.REACT_APP_BASE_URL}/v3/document/preview/file/${data.DOCUMENT_ID}/${encodedFileName}`
                                                        : '',
                                                    downloadUrl: rawFileName
                                                        ? `${process.env.REACT_APP_BASE_URL}/v3/document/download/file/${data.DOCUMENT_ID}/${encodedFileName}`
                                                        : '',
                                                    onDownload: rawFileName
                                                        ? () => handleDownloadFile(data.DOCUMENT_ID, rawFileName, displayName)
                                                        : null,
                                                };
                                            })}
                                            onDownloadAll={() => handleDownload(data.DOCUMENT_ID)}
                                        />
                                    </div>
                                </td>
                                <td></td>
                                <td>{data.DESCRIPTION || '-'}</td>
                            </tr>

                        </tbody>
                    </table>
                    <table className="table table-info-bx">
                        <tbody>
                            <tr>
                                <td><p className="text-muted mb-0"><b>Created by</b> {data.CREATED_BY_NAME}</p></td>

                            </tr>
                            <tr>
                                <td><p className="text-muted mb-0"><b>Modified On</b> {moment(data.MODIFIED_ON).format('MMM DD YYYY')}</p></td>

                            </tr>
                            <tr>
                                <td><p className="text-muted mb-0"><b>Remark</b> {data.DESCRIPTION || '-'}</p></td>
                            </tr>
                        </tbody>
                    </table>

                    {data.comments?.map((comment, idx) => (
                        <div key={idx} className='CommentBox'>
                            <p>{comment.COMMENT}</p>
                            <h5>Commented By: <span>{comment.COMMENTED_BY_NAME}</span></h5>
                            <h5>Date: <span>{moment(comment.CREATED_ON).format('DD MMM, YYYY')}</span></h5>

                        </div>


                    ))}




                </div>
                <div className='commentsSection'>
                    {/* <h3>Add Comment</h3> */}
                    <form onSubmit={handleSubmit}>
                        <div class="form-control1">
                            {/* <div class="label-form">Add Comment</div> */}
                            <div class="input-form ">
                                <textarea type="text" class="form-control" placeholder=""
                                    value={state.comment.value}
                                    name={state.comment.name}
                                    onChange={handleChange}
                                />
                            </div>

                        </div>
                        <div className="form-group mt-2">
                            <button
                                className="btn btn-primary"
                                type='submit'
                                style={{ backgroundColor: '#29577b', borderColor: '#29577b' }}
                            >
                                Add Comment
                            </button>
                        </div>

                    </form>

                </div>

            </div>
        </div>
    )
}

export default DocumentDetail
